import { Component } from '@theme/component';

/**
 * Handles category hover/click persistence for the custom SKNLY products mega menu.
 *
 * @typedef {Object} Refs
 * @property {HTMLButtonElement[]} [category]
 * @property {HTMLElement[]} [panel]
 *
 * @extends {Component<Refs>}
 */
class SknlyProductMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#bindInteractions();
  }

  #bindInteractions() {
    const categories = this.refs.category || [];

    for (const button of categories) {
      button.addEventListener('pointerenter', this.#handleActivate);
      button.addEventListener('focus', this.#handleActivate);
      button.addEventListener('click', this.#handleActivate);
    }
  }

  /**
   * @param {Event} event
   */
  #handleActivate = (event) => {
    const target = event.currentTarget;
    if (!(target instanceof HTMLButtonElement)) return;

    const index = Number(target.dataset.panelIndex);
    if (Number.isNaN(index)) return;

    this.#setActivePanel(index);
  };

  /**
   * @param {number} activeIndex
   */
  #setActivePanel(activeIndex) {
    const categories = this.refs.category || [];
    const panels = this.refs.panel || [];

    for (const button of categories) {
      const index = Number(button.dataset.panelIndex);
      const isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (const panel of panels) {
      const index = Number(panel.dataset.panelIndex);
      const isActive = index === activeIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    }
  }
}

if (!customElements.get('sknly-product-menu')) {
  customElements.define('sknly-product-menu', SknlyProductMenu);
}
